module.exports = __webpack_public_path__ + "static/media/star_1.28b6270f.svg";